export default __webpack_public_path__ + "static/media/Maytag@3x.5063df6c.png";